import React, {useState} from "react";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Pagination} from "swiper/modules";
import Message from "../Message";
import { isFirefox } from "../../../utils/browserDetection";
import "./style.scss";

const DELAY_SWIPER = 10000;

const FixedMessages = (
    {
        type,
        messages,
        currentUser,
        fixedLineMessage = 3,
    }) => {
    const [openMessageIndex, setOpenMessageIndex] = useState(null);
    const [activeMessageIndex, setActiveMessageIndex] = useState(0);

    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return `<span class="${className}"><div class="-item"></div></span>`;
        },
        bulletClass: `messages-fixed-swiper--bullet ${messages?.length <= 1 ? 'hidden' : ''}`,
        bulletActiveClass: 'active',
    };

    if (!messages.length) {
        return null;
    }

    return (
        <div className={`messages-fixed`}>
            <div className={`messages-fixed-wrapper scrollable`}>
                <Swiper
                    onSlideChange={(e) => setActiveMessageIndex(e.activeIndex)}
                    className="messages-fixed-swiper"
                    autoplay={{
                        delay: DELAY_SWIPER,
                        disableOnInteraction: false,
                    }}
                    pagination={pagination}
                    modules={[Autoplay, Pagination]}
                >
                    {messages?.map((message, index) => (
                        <SwiperSlide key={message.id}>
                            <Message
                                isHideTime
                                message={message}
                                fixedLine={!isFirefox && fixedLineMessage}
                                currentUser={currentUser}
                                type={type}
                                isHideMessage={openMessageIndex === index && activeMessageIndex !== index}
                                changeOpenMessageIndex={(isOpen) => setOpenMessageIndex(isOpen ? index : null)}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <hr />
        </div>
    );
};

export default FixedMessages;
